import { useTogglePresentationMode } from '@euler/app/components/PresentationModeContext';
import { useLogout } from '@euler/app/flows/auth/hooks';
import { TVNavParams } from '@euler/app/Routes.tv';
import {
  FloatingModalScreen,
  FloatingModalScreenRef,
} from '@euler/app/tv/components/FloatingModalScreen';
import { SettingsModalContent } from '@euler/app/tv/components/settings/SettingsModalContent';
import { tvModalScreenOptions } from '@euler/app/tv/functions/utils';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback, useRef } from 'react';

export const SettingsScreen = wrapNavigatorScreen(() => {
  const navigation = useNavigation<StackNavigationProp<TVNavParams>>();
  const logout = useLogout();

  const ref = useRef<FloatingModalScreenRef>(null);

  const onCheckUpdates = useCallback(async () => {
    ref.current?.dismiss(() => {
      navigation.navigate('_update', {});
    });
  }, [navigation]);

  const onVersionPress = useCallback(() => {
    ref.current?.dismiss(() => {
      navigation.navigate('_debugPanel', {});
    });
  }, [navigation]);

  const onStoreInfoPress = useCallback(() => {
    ref.current?.dismiss(() => {
      navigation.navigate('StoreInfo', {});
    });
  }, [navigation]);

  const onAboutPress = useCallback(() => {
    ref.current?.dismiss(() => {
      navigation.navigate('About', {});
    });
  }, [navigation]);

  const togglePresentationMode = useTogglePresentationMode();

  const onExitPresentationMode = useCallback(async () => {
    ref.current?.dismiss(async () => {
      void togglePresentationMode();
    });
  }, [togglePresentationMode]);

  const onLogoutPress = useCallback(() => {
    ref.current?.dismiss(async () => {
      void logout();
    });
  }, [logout]);

  return (
    <FloatingModalScreen ref={ref}>
      <SettingsModalContent
        onLogoutPress={onLogoutPress}
        onCheckUpdatesPress={onCheckUpdates}
        onVersionPress={onVersionPress}
        onStoreInfoPress={onStoreInfoPress}
        onAboutPress={onAboutPress}
        onExitPresentationMode={onExitPresentationMode}
      />
    </FloatingModalScreen>
  );
}, tvModalScreenOptions);
